<template>
  <div>
    <b-container>
      <router-view />
    </b-container>
    <notifications group="notify-group" width="350" position="top center" style="top: 84px;" />
  </div>
</template>

<script>
export default {};
</script>
